<template>
    <div id="ModuleSelectorOne">
        <div class="title-text">
            <h2>{{ $t("customerInteractionChannelsText") }}</h2>
            <h3 v-html="$t('multipleSystemsSelectionText')"></h3>
        </div>
        <div class="content">
            <div class="module-selector-container">
                <div class="form-now" ref="formNow">
                    <h2>{{ $t("platformsText") }}</h2>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <WhatsappBIcon />
                            </div>
                            <div class="item-text">{{ $t("whatsappBusinessApiText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input 
                                    type="checkbox" 
                                    :checked="selectedModules.whatsappBusiness"
                                    data-module="whatsappBusiness"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <WhatsappIcon />
                            </div>
                            <div class="item-text">{{ $t("whatsappWebText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input 
                                    type="checkbox" 
                                    :checked="selectedModules.whatsappWeb"
                                    data-module="whatsappWeb"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <InstagramIcon />
                            </div>
                            <div class="item-text">{{ $t("instagramIntegrationText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input 
                                    type="checkbox" 
                                    :checked="selectedModules.instagram"
                                    data-module="instagram"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <MessengerIcon />
                            </div>
                            <div class="item-text">{{ $t("facebookIntegrationText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input 
                                    type="checkbox" 
                                    :checked="selectedModules.facebook"
                                    data-module="facebook"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <TelegramIcon />
                            </div>
                            <div class="item-text">{{ $t("telegramIntegrationText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input 
                                    type="checkbox" 
                                    :checked="selectedModules.telegram"
                                    data-module="telegram"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <MailIcon />
                            </div>
                            <div class="item-text">{{ $t("mailManagementSystemText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input 
                                    type="checkbox" 
                                    :checked="selectedModules.mail"
                                    data-module="mail"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <WebSiteIcon />
                            </div>
                            <div class="item-text">{{ $t("webChatText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input 
                                    type="checkbox" 
                                    :checked="selectedModules.webChat"
                                    data-module="webChat"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <AiIcon />
                            </div>
                            <div class="item-text">{{ $t("aiText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input 
                                    type="checkbox" 
                                    :checked="selectedModules.ai"
                                    data-module="ai"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <MetaIcon />
                            </div>
                            <div class="item-text">{{ $t("metaLeadTrackingText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input 
                                    type="checkbox" 
                                    :checked="selectedModules.metaLead"
                                    data-module="metaLead"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <TrendyolIcon />
                            </div>
                            <div class="item-text">{{ $t("trendyolIntegrationText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input 
                                    type="checkbox" 
                                    :checked="selectedModules.trendyol"
                                    data-module="trendyol"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox($event)">
                        <div class="item-top">
                            <div class="item-icon">
                                <LinkedinIcon />
                            </div>
                            <div class="item-text">{{ $t("linkedinIntegrationText") }}</div>
                            <label class="item-checkbox" @click.stop>
                                <input
                                    type="checkbox"
                                    :checked="selectedModules.linkedin"
                                    data-module="linkedin"
                                    @change="toggleCheckbox"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div
                    class="scroll-indicator"
                    v-show="showScrollDownButton"
                    @click="scrollDown"
                >
                    <ArrowDownIcon  class="scroll-icon" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WhatsappIcon from "../../icon/WhatsappIcon.vue";
import WhatsappBIcon from "../../icon/WhatsappBIcon.vue";
import InstagramIcon from "../../icon/InstagramIcon.vue";
import MessengerIcon from "../../icon/MessengerIcon.vue";
import TelegramIcon from "../../icon/TelegramIcon.vue";
import MailIcon from "../../icon/MailIcon.vue";
import WebSiteIcon from "../../icon/WebSiteIcon.vue";
import AiIcon from "../../icon/AiIcon.vue";
import MetaIcon from "../../icon/MetaIcon.vue";
import TrendyolIcon from "../../icon/TrendyolIcon.vue";
import ArrowDownIcon from "../../icon/ArrowDownIcon.vue";
import LinkedinIcon from "../../icon/LinkedinIcon.vue";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../utils/formStore";

export default {
    name: "ModuleSelectorOne",
    components: {
        WhatsappIcon,
        WhatsappBIcon,
        InstagramIcon,
        MessengerIcon,
        TelegramIcon,
        MailIcon,
        WebSiteIcon,
        AiIcon,
        MetaIcon,
        TrendyolIcon,
        ArrowDownIcon,
        LinkedinIcon
    },
    data() {
        return {
            selectedModules: {
                whatsappBusiness: false,
                whatsappWeb: false,
                instagram: false,
                facebook: false,
                telegram: false,
                mail: false,
                webChat: false,
                ai: false,
                metaLead: false,
                trendyol: false,
                linkedin: false
            },
            showScrollDownButton: false,
        };
    },
    mounted() {
        this.$nextTick(() => {
            const formNow = this.$refs.formNow;
            if (formNow) {
                formNow.addEventListener("scroll", this.handleScroll);
                // İlk yüklemede kontrol et
                this.handleScroll();
            }
        });
    },
    methods: {
        toggleCheckbox(event) {
            const item = event.currentTarget;
            const checkbox = item.querySelector('input[type="checkbox"]');
            const moduleKey = checkbox.dataset.module;
            if (moduleKey) {
                const newValue = !this.selectedModules[moduleKey];
                this.selectedModules[moduleKey] = newValue;
                checkbox.checked = newValue;

                saveToLocalStorage({
                    moduleSelections: this.selectedModules
                });
            }
        },
        scrollDown() {
            const formNow = this.$refs.formNow;
            if (formNow) {
                formNow.scrollBy({
                    top: 200,
                    behavior: "smooth",
                });
            }
        },
        handleScroll() {
            const formNow = this.$refs.formNow;
            if (formNow) {
                const { scrollTop, scrollHeight, clientHeight } = formNow;
                this.showScrollDownButton = scrollTop + clientHeight < scrollHeight - 50;
            }
        }
    },
    watch: {
        selectedModules: {
            handler(newVal) {
                saveToLocalStorage({ moduleSelections: newVal });
            },
            deep: true
        }
    },
    created() {
        const saved = loadFromLocalStorage().moduleSelections || {};
        this.selectedModules = {
            whatsappBusiness: saved.whatsappBusiness || false,
            whatsappWeb: saved.whatsappWeb || false,
            instagram: saved.instagram || false,
            facebook: saved.facebook || false,
            telegram: saved.telegram || false,
            mail: saved.mail || false,
            webChat: saved.webChat || false,
            ai: saved.ai || false,
            metaLead: saved.metaLead || false,
            trendyol: saved.trendyol || false,
            linkedin: saved.linkedin || false
        };
    },
    beforeDestroy() {
        const formNow = this.$refs.formNow;
        if (formNow) {
            formNow.removeEventListener("scroll", this.handleScroll);
        }
    }
};
</script>

<style lang="scss" scoped>
#ModuleSelectorOne {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    background-image: url("../../../assets/BackgroundOne.png");
    background-repeat: no-repeat;
    background-size: cover;

    .title-text {
        font-family: 'Plus Jakarta Sans', sans-serif;
        padding: 0 20px;
        animation: slideDown 0.8s ease;

        h2 {
            font-size: 1.7rem;
            color: #272657;
            font-weight: bold;

            @media (max-width: 768px) {
                font-size: 1.8rem;
                text-align: center;
            }
        }

        h3 {
            color: #64607D;
            font-weight: 100;

            @media (max-width: 768px) {
                font-size: 1rem;
                text-align: center;
            }
        }
    }

    @media(max-width: 768px) {
        .module-selector-container{
            height: 33vh !important;
        }
        .form-now{
            height: 30vh !important;
        }
    }

    .content {
        display: flex;
        justify-content: center;
        padding: 0 20px;

        .module-selector-container {
            position: relative;
            padding: 30px;
            background: #fff;
            width: 600px;
            height: 48vh;
            border-radius: 20px;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
            animation: fadeIn 1s ease;

            @media (max-width: 768px) {
                width: 100%;
                padding: 20px;
                border-radius: 15px;
            }

            .form-now {
                width: 100%;
                max-width: 600px;
                margin: auto;
                font-family: Arial, sans-serif;
                height: 46vh;
                overflow-y: auto;
                padding: 10px;

                h2 {
                    text-align: left;
                    margin-top: -10px;
                    color: #272657;
                    opacity: 0;
                    animation: slideRight 0.8s ease forwards;
                    animation-delay: 0.5s;
                }
                .item {
                    margin-left: -7px;
                    position: relative;
                    display: flex;
                    align-items: flex-start;
                    flex-direction: column;
                    padding: 15px 20px;
                    border: 1px solid #ddd;
                    border-radius: 10px;
                    margin-bottom: 15px;
                    transition: all 0.5s ease;
                    cursor: pointer;
                    overflow: hidden;
                    opacity: 0;
                    animation: slideUp 0.5s ease forwards;

                    @for $i from 1 through 10 {
                        &:nth-child(#{$i + 1}) {
                            animation-delay: #{($i * 0.2) + 0.8}s;
                        }
                    }

                    @media (max-width: 768px) {
                        padding: 12px 15px;
                    }

                    .item-top {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;
                        flex-wrap: nowrap;

                        @media (max-width: 768px) {
                            flex-wrap: nowrap;
                            gap: 10px;
                            
                            .item-text {
                                font-size: 14px;
                                margin-left: 10px;
                                flex: 1;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }

                            .item-icon {
                                flex-shrink: 0;
                                width: 20px;
                                height: 20px;
                            }

                            .item-checkbox {
                                flex-shrink: 0;
                            }
                        }

                        .item-icon {
                            width: 30px;
                            height: 30px;

                            @media (max-width: 768px) {
                                width: 25px;
                                height: 25px;
                            }
                        }

                        .item-text {
                            flex-grow: 1;
                            margin-left: 15px;
                            font-size: 18px;
                            color: #444;
                            text-align: left;

                            @media (max-width: 768px) {
                                font-size: 16px;
                                margin-left: 10px;
                            }
                        }

                        .item-checkbox {
                            input[type="checkbox"] {
                                opacity: 0;
                                position: absolute;
                                pointer-events: none;
                                
                                &:checked + .checkmark {
                                    background-color: #5d5b8d;
                                    border-color: #5d5b8d;
                                    
                                    &::after {
                                        display: block;
                                    }
                                }
                            }
                            
                            .checkmark {
                                height: 24px;
                                width: 24px;
                                background-color: #fff;
                                border: 1px solid #ccc;
                                border-radius: 50%;
                                display: inline-block;
                                position: relative;

                                &::after {
                                    content: "";
                                    position: absolute;
                                    display: none;
                                    left: 8px;
                                    top: 4px;
                                    width: 6px;
                                    height: 10px;
                                    border: solid #fff;
                                    border-width: 0 2px 2px 0;
                                    transform: rotate(45deg);
                                }
                            }
                        }
                    }

                    .item-description {
                        max-height: 0;
                        opacity: 0;
                        margin-top: 0;
                        transition: all 0.5s ease;
                        overflow: hidden;
                        width: 100%;
                        
                        p {
                            margin: 10px 0 0 0;
                            font-size: 14px;
                            color: #666;
                            line-height: 1.5;

                            @media (max-width: 768px) {
                                font-size: 13px;
                                line-height: 1.4;
                            }
                        }
                    }

                    &:hover {
                        box-shadow: 0px 0px 20px 0px rgba(232, 228, 243);
                        transform: scale(1.02);
                        transition: all 0.5s ease;
                        
                        .item-description {
                            max-height: 200px;
                            opacity: 1;
                            margin-top: 10px;
                        }
                    }

                    @media (hover: none) {
                        &:active {
                            box-shadow: 0px 0px 20px 0px rgba(232, 228, 243);
                            transform: scale(1.01);

                            .item-description {
                                max-height: 200px;
                                opacity: 1;
                                margin-top: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-50px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideRight {
    from {
        opacity: 0;
        transform: translateX(-30px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.scroll-indicator {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -50px;
    margin: auto;
    width: fit-content;
    transform: translateY(-20px);
    background: #5d5b8d;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transition: all 0.3s ease;
    z-index: 1000;
    padding: 5px;

    &:hover {
        background: #4a4870;
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.95);
    }

    .scroll-icon {
        color: white;
        font-size: 18px;
    }
}

@media (max-width: 768px) {
    .scroll-indicator {
        display: none !important;
    }

    .module-selector-container {
        width: 100%;
        padding: 20px;
        border-radius: 15px;
    }

    .scroll-indicator {
        left: -45px;
        bottom: 15px;
        width: 35px;
        height: 35px;
    }
}
</style>